import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";

import constvar from "../components/Common/Constant";

import { frontendRoutes } from "../routes/Index";
import Header from "./Header";
import Footer from "./Footer";
import { GlobalProvider } from "../context/GlobalContext";
import UserPrivateRoutes from "../routes/userPrivateRoutes";
import PrivateIndex from "./PrivateIndex";
import { AuthContextProvider, AuthContext } from "../context/AuthContext";
import axios from "axios";
import { axios_interceptor } from "../axios_interceptor/AxiosInterceptor";
import LoaderSpinner from "../component/LoaderSpinner";
import HelmetMetaData from "../components/HelmetMetaData/HelmetMetaData";

import { SnackbarProvider } from "notistack";

global.constvar = constvar;
global.axios = axios;

export function Index() {
  const [isloading, setLoading] = useState(true);
  const location = useLocation();

  // Routes that have internal loading states - don't show spinner for these
  const detailRoutes = [
    /^\/jobs\/.+/,           // /jobs/:slug
    /^\/blog\/\d+/,           // /blog/:id
    /^\/training\/.+/,        // /training/:slug
    /^\/company\/.+/,         // /company/:clientslug
    /^\/pages\/.+/,           // /pages/:slug
    /^\/other_cms\/\d+/,      // /other_cms/:id
    /^\/reference_verify\/.+/ // /reference_verify/:reftoken
  ];

  const isDetailRoute = detailRoutes.some(pattern => pattern.test(location.pathname));

  useEffect(() => {
    axios_interceptor();
    const token = window.localStorage.getItem("frontend-jwt-token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    // Don't show loader for detail routes to prevent component unmount/remount
    if (!isDetailRoute) {
      setTimeout(() => setLoading(false), 300);
      return () => {
        setLoading(true);
      };
    } else {
      setLoading(false);
    }
  }, [location.pathname, isDetailRoute]);
  const notistackRef = React.createRef();
  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <GlobalProvider>
      <SnackbarProvider
        maxSnack={3}
        hideIconVariant={false}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={3000}
        ref={notistackRef}
        action={(key) => (
          <a
            className="text-white pr-4 cursor-pointer hover:opacity-80"
            onClick={onClickDismiss(key)}
          >
            X
          </a>
        )}
      >
        <AuthContextProvider>
          {/* <ConfirmationDialogProvider>
          <HelmetMetaData /> */}
          <Header />

          <Switch>
            {frontendRoutes.map((route, idx) => {
              return route.component ? (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={(props) => (
                    <React.Fragment>
                      {isloading && route.name != "Home" ? (
                        <LoaderSpinner />
                      ) : (
                        <route.component {...props} />
                      )}
                    </React.Fragment>
                  )}
                />
              ) : null;
            })}
            <UserPrivateRoutes
              // path="/profile"
              // name="Dashboard"
              // exact={true}
              component={PrivateIndex}
            />
            <Redirect from="/" to="/error_page" />
          </Switch>

          <Footer />
        </AuthContextProvider>
      </SnackbarProvider>
    </GlobalProvider>
  );
}
export default Index;
